<template>
  <b-dropdown
    :id="id"
    :text="selectedText"
    class="dropdown__exteded"
    right
    :no-caret="isIconAction"
  >
    <template v-if="isIconAction" #button-content>
      <slot></slot>
    </template>
    <div
      v-for="(item, index) in items"
      :key="`drop-item-${index}`"
      class="pl-2 pr-3"
    >
      <b-dropdown-item-button
        v-if="item.isButtonType"
        @click="onSelectedItem(item)"
      >
        <div class="d-flex align-items-center">
          <em
            v-if="item.icon"
            :class="`fas fa-${item.icon}`"
            style="width: 20px"
          />
          <span>{{ item.label }}</span>
        </div>
      </b-dropdown-item-button>
      <b-dropdown-item v-else>
        {{ item.label }}
      </b-dropdown-item>
      <b-dropdown-divider v-if="item.hasDivider"></b-dropdown-divider>
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'CustomDropActionItem',
  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    isIconAction: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    setSelectedOption: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedValue: null,
  }),
  computed: {
    selectedText() {
      return this.setSelectedOption && this.selectedValue?.label
        ? this.selectedValue.label
        : this.text;
    },
    isButtonType() {
      return (item) => item?.isButtonType;
    },
  },
  watch: {
    value: {
      handler(currentValue, oldValue) {
        if (this.setSelectedOption && currentValue !== oldValue) {
          this.selectedValue = currentValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onSelectedItem(value) {
      if (this.setSelectedOption) {
        this.selectedValue = { ...value };
      }
      this.$emit('click', { ...value });
    },
  },
};
</script>

<style scoped lang="scss">
.dropdown__exteded ::v-deep {
  height: unset !important;
  .dropdown-toggle {
    background: unset;
    border: unset;
    color: #1da7af;
    &:active {
      color: #1da7af;
      background-color: unset;
      border-color: unset;
      box-shadow: unset;
    }
    &:focus {
      box-shadow: unset;
    }
    &::after {
      margin-left: 10px;
      border-top: unset;
      vertical-align: unset;
      font: normal normal normal 14px/1 FontAwesome;
      content: '\f107' !important;
    }
  }

  .dropdown-menu {
    .dropdown-item {
      color: #1da7af;
      font-size: 14px;
      margin-bottom: 5px;
      padding: 10px 10px;
      &:hover {
        background: #e8fbfc;
      }
      &:focus {
        background: #e8fbfc;
      }
    }
  }
}

.dropdown__exteded.show ::v-deep {
  .dropdown-toggle {
    &::after {
      font: normal normal normal 14px/1 FontAwesome;
      content: '\f106' !important;
    }
  }
}
</style>
